import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { injectIntl, useIntl } from 'react-intl';
import intlShape from '@/shared/utils/intlShape';
import enumCache from '@/shared/services/EnumCacheService';

class TrainingStatusButtonGroup extends Component {
  state = {
    trainingStatuses: [],
  };

  componentDidMount() {
    const { intl } = this.props;
    enumCache.getTranslated('trainingstatus', intl).then(trainingStatuses => {
      this.setState({
        trainingStatuses: trainingStatuses,
      });
    });
  }

  toggleTrainingStatus = trainingStatus => {
    const { selectedStatuses, onChange } = this.props;

    if (selectedStatuses && selectedStatuses.includes(trainingStatus)) {
      onChange(selectedStatuses.filter(s => s !== trainingStatus));
    } else {
      onChange([...(selectedStatuses || []), trainingStatus]);
    }
  };

  render() {
    const { trainingStatuses } = this.state;
    const { selectedStatuses } = this.props;

    return (
      <div role="group" aria-label="trainingStatus" className="btn-group btn-group-justified">
        {trainingStatuses &&
          trainingStatuses.map(t => (
            <button
              key={`TrainingStatusFilter${t.id}`}
              onClick={() => {
                document.activeElement.blur();
                this.toggleTrainingStatus(t.id);
              }}
              type="button"
              title={t.label}
              className={classnames('btn btn-default', {
                active: selectedStatuses && selectedStatuses.includes(t.id),
              })}
            >
              {t.label}
            </button>
          ))}
      </div>
    );
  }
}

TrainingStatusButtonGroup.propTypes = {
  intl: intlShape.isRequired,
  selectedStatuses: PropTypes.arrayOf(PropTypes.number),
  onChange: PropTypes.func.isRequired,
};

TrainingStatusButtonGroup.defaultProps = {
  selectedStatuses: [],
};

export default injectIntl(TrainingStatusButtonGroup);
